import { isSodimacStandalone } from '@digital-retail/store-manager';
import _ from 'lodash';
import apiConfig from '../../../config/api/apiConfig';
import constants from '../../../config/constants';
import httpService from '../../../utils/httpService';
import { getCommerceHeaders } from '../../../utils/tenantHelper';
import { getSelectedPickupInStoreDetails } from './PickupInStore/PickupInStore.Helper';
import { getStockInStoreInfo } from './StockInStore/StockInStore.Helper';

const { AVAILABILITY_PICKUPINSTORE, AVAILABILITY_STOCKINSTORE, AVAILABILITY_HOMEDELIVERY } = constants;

const getScreen = ({ type, sizes, isSizeSelected, pickupInStoreData, storesList, homeDeliveryData, isError }) => {
  const handlers = {
    HomeDelivery: () => {
      if (!isSizeSelected && sizes.length > 0) {
        return 'screen1';
      }
      if (isError && isError.HomeDelivery && isError.HomeDelivery.isError) {
        return 'screen3';
      }
      return homeDeliveryData && !_.isEmpty(homeDeliveryData) ? 'screen3' : 'screen2';
    },
    PickupInStore: () => {
      if (!isSizeSelected && sizes.length > 0) {
        return 'screen1';
      }
      if (isError && isError.PickupInStore && isError.PickupInStore.isError) {
        return 'screen3';
      }
      return pickupInStoreData && !_.isEmpty(pickupInStoreData) ? 'screen3' : 'screen2';
    },

    StockInStore: () => {
      if (!isSizeSelected && sizes.length > 0) {
        return 'screen1';
      }
      if (isError && isError.StockInStore && isError.StockInStore.isError) {
        return 'screen3';
      }

      return !_.isEmpty(storesList) ? 'screen3' : 'screen2';
    },
  };

  const handler = handlers[type];
  if (handler) {
    return handler();
  }
  return type === AVAILABILITY_STOCKINSTORE ? 'screen3' : 'screen2';
};

const getSelectedData = (data, type, zoneConfig, isDefaultComuna) => {
  const { title, price, date = '', month = '', storeName = '', storeId = '', isDateRange = false } = data[0];
  const locationName = _.get(zoneConfig, isDefaultComuna ? 'comunaName' : 'name', '');
  const parentStateName = zoneConfig?.parentStateName || '';
  const politicalId = _.get(zoneConfig, 'politicalId', '');

  if (type === AVAILABILITY_HOMEDELIVERY) {
    return {
      selectedType: title,
      price,
      date,
      month,
      storeName,
      storeId,
      isValid: true,
      locationName,
      politicalId,
      isDateRange,
      parentStateName,
    };
  }
  if (type === AVAILABILITY_PICKUPINSTORE) {
    return {
      selectedType: title,
      price,
      date,
      month,
      storeName,
      storeId,
      isValid: true,
      locationName,
      politicalId,
      isDateRange,
    };
  }
  return {
    selectedType: '',
    price: '',
    date: '',
    month: '',
    locationName: '',
    storeName: '',
    storeId: '',
    isValid: false,
    politicalId: '',
  };
};

const processStoreId = ({
  storeId,
  storesData,
  setSelectedStoreId,
  setSelectedStoreDetails,
  setSelectedStoreName,
  regionCode,
  zoneConfig,
  isFreeShippingApplicable,
  setSelectedDeliveryOption,
  parentStateName,
  type,
  stockCategoryConfig,
  stockCategoryLimit,
  textDictionary,
  isDefaultComuna,
}) => {
  const storeDetails = storesData.find((data) => {
    if (type === AVAILABILITY_PICKUPINSTORE) {
      return data.storeId === storeId;
    }
    if (type === AVAILABILITY_STOCKINSTORE) {
      return data.id === storeId;
    }
    return data.storeId === storeId;
  });
  if (storeDetails && !_.isEmpty(storeDetails)) {
    if (type === AVAILABILITY_PICKUPINSTORE) {
      const mySelectedStoreDetails = getSelectedPickupInStoreDetails(storeDetails, regionCode);
      setSelectedStoreDetails(mySelectedStoreDetails);
      setSelectedStoreId(storeId);
      setSelectedStoreName(_.get(storeDetails, 'storeName', ''));
      const { selectedType, price, date, month, storeName, isValid, locationName, politicalId, isDateRange } =
        getSelectedData(mySelectedStoreDetails, type, zoneConfig, isFreeShippingApplicable, isDefaultComuna);
      if (isValid) {
        setSelectedDeliveryOption({
          type: selectedType,
          price,
          date,
          month,
          locationName,
          storeName,
          storeId,
          politicalId,
          isError: false,
          isDateRange,
          isFreeShippingApplicable,
          parentStateName,
          deliveryOptionType: type,
        });
      }
    } else {
      const { storeName, textUnits, operatorIcon, isValid, classUnits } = getStockInStoreInfo(
        storeDetails,
        stockCategoryConfig,
        stockCategoryLimit,
        textDictionary
      );
      if (isValid) {
        setSelectedDeliveryOption({
          type: '',
          price: '',
          date: '',
          month: '',
          locationName: '',
          storeName,
          storeId,
          politicalId: '',
          isError: false,
          isDateRange: '',
          isFreeShippingApplicable,
          parentStateName,
          textUnits,
          operatorIcon,
          classUnits,
          deliveryOptionType: type,
        });
      }
    }
    return true;
  }
  return false;
};
const checkAvailability = ({ isHomeDelivery, isPickupInStore, isStockInStore, zoneConfig, setScreen }) => {
  if (isHomeDelivery) {
    if (zoneConfig && !_.isEmpty(zoneConfig)) {
      setScreen('screen2');
    }
  } else if (isPickupInStore || isStockInStore) {
    setScreen('screen2');
  }
};

const getDeliveryOptionBorderClassName = (isWhitelabelSite) => {
  if (isWhitelabelSite) return 'whitelabel';
  return '';
};

const getDeliveryOptionIconClassName = (className, isWhitelabelSite) => {
  if (isWhitelabelSite) return `whitelabel-${className}`;
  return className;
};

const getTitle = ({ isHomeDelivery, HOME_DELI_TITLE, PICKUP_INSTORE_TITLE }) => {
  return isHomeDelivery ? HOME_DELI_TITLE : PICKUP_INSTORE_TITLE;
};

const getZoneName = (zone, isDefaultComuna) => {
  if (!zone || typeof zone !== 'object') {
    return { comunaName: '', regionName: '' };
  }

  const comunaName = isDefaultComuna
    ? zone.comunaName || zone.name
    : zone.comuna?.name || zone.name || zone.comunaName || '';

  const regionName = zone.region?.name || zone.parentStateName || zone.regionName || '';

  return { comunaName, regionName };
};

const getCommonZoneModalProps = ({
  deviceType,
  regionCode,
  reloadOnZoneChange,
  modalVisible,
  setModalVisible,
  store,
  zoneConfig,
  isDefaultComuna,
  selectedZone,
  isPickupInStore,
  isHomeDelivery,
  isStockInStoreFlag,
  getStockInStoreDataSlotsData,
  getDeliveryEstimatesV2SlotsData,
  setModalBusy,
  saveZones,
  isError,
  setScreen,
}) => {
  const commonCallbacks = {
    getStockEnTiendaData: (comuna) => getStockInStoreDataSlotsData(comuna, setModalBusy),
    getDeliveryEstimatesV2Data: (comuna) => getDeliveryEstimatesV2SlotsData(comuna, setModalBusy),
  };

  return {
    deviceType,
    tenant: regionCode,
    entry: {},
    handleRouteChange: reloadOnZoneChange,
    isBrandingMarketplace: true,
    modalVisible,
    setModalVisible,
    isOnboardingInProgress: false,
    isStore: !!store,
    enableSisThemedBorder: true,
    isSodimacStandAlone: isSodimacStandalone(store),
    isPopOverVisible: false,
    isDefaultComuna: isPickupInStore ? _.isEmpty(zoneConfig) : isDefaultComuna,
    selectedZone: isPickupInStore ? zoneConfig : selectedZone,
    store,
    isError,
    setScreen,
    setZoneConfig: ({ comuna }) =>
      saveZones({
        dataZoneConfig: comuna,
        isHomeDelivery,
        isPickupInStore,
        isStockInStore: isStockInStoreFlag,
        setModalVisible,
      }),
    ...commonCallbacks,
  };
};

const getTypeSpecificProps = ({
  type,
  zoneConfig,
  isStockInStore,
  setModalVisible,
  comunaName,
  selectedStoreId,
  pickupInStoreData,
  homeDeliveryData,
  setSelectedStoreId,
  setModalBusy,
}) => {
  if (isStockInStore) {
    return {
      stockEnTienda: {
        type,
        zoneConfig,
        setSelectedStoreId,
        actions: {
          close: () => setModalVisible(false),
          setBusy: setModalBusy,
        },
        comunaName,
      },
      deliveryOptions: {
        type,
        setSelectedStoreId,
        actions: {
          close: () => setModalVisible(false),
          setBusy: setModalBusy,
        },
        pickupInStoreData,
        selectedPickupInStoreId: selectedStoreId,
        disableButton: !(homeDeliveryData.length || pickupInStoreData.length),
        comunaName,
      },
    };
  }
  return {
    deliveryOptions: {
      type,
      setSelectedStoreId,
      actions: {
        close: () => setModalVisible(false),
        setBusy: setModalBusy,
      },
      pickupInStoreData,
      selectedPickupInStoreId: selectedStoreId,
      disableButton: !(homeDeliveryData.length || pickupInStoreData.length),
      comunaName,
    },
    stockEnTienda: {
      type,
      zoneConfig,
      setSelectedStoreId,
      actions: {
        close: () => setModalVisible(false),
        setBusy: setModalBusy,
      },
      comunaName,
    },
  };
};

const getDeliveryEstimatesV2Data = async ({
  comuna,
  setBusy,
  regionCode,
  store,
  offeringId,
  setParentStateName,
  getHomeDeliverySlotsData,
  getPickupInStoreSlotsData,
}) => {
  if (comuna && !_.isEmpty(comuna)) {
    setBusy(true);
    setParentStateName(_.get(comuna, 'parentStateName', ''));
    const state = _.get(comuna, 'parentStateId', '');
    const municipal = _.get(comuna, 'politicalId', '');
    const lat = _.get(comuna, 'latitude', '');
    const long = _.get(comuna, 'longitude', '');

    try {
      const commerceHeaders = getCommerceHeaders(regionCode, store);
      const res = await httpService().get(
        apiConfig.getDeliveryEstimatesV2Url(regionCode, state, municipal, lat, long, offeringId),
        {
          headers: commerceHeaders,
        },
        'json'
      );

      const responseData = res?.data || {};
      const { storePickUp = null, homeDelivery = null } = responseData;

      getPickupInStoreSlotsData(comuna, storePickUp);
      getHomeDeliverySlotsData(comuna, homeDelivery);
    } catch (error) {
      getPickupInStoreSlotsData(comuna, null);
      getHomeDeliverySlotsData(comuna, null);
    }
    setBusy(false);
  }
};

export {
  checkAvailability,
  getCommonZoneModalProps,
  getDeliveryEstimatesV2Data,
  getDeliveryOptionBorderClassName,
  getDeliveryOptionIconClassName,
  getScreen,
  getSelectedData,
  getTitle,
  getTypeSpecificProps,
  getZoneName,
  processStoreId,
};
